<script>
export default {
  props: ['route'],
  data: () => ({
    enter: false
  }),
  methods: {
    historyBack () {
      this.route ? this.$router.push(this.route) : this.$router.go(-1)
    }
  },
  mounted () {
    this.enter = true
  }
}
</script>
<template>
  <transition name="slide-up">
    <div class="modal" v-if="enter" :class="{'is-active': enter}">
      <div class="modal-background" @click="historyBack"></div>
      <div class="modal-content">
        <slot></slot>
      </div>
      <div class="close-icon" @click="historyBack">
        <span class="icon">
          <i class="c-icon cachalog-close"></i>
        </span>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// src/components/view/c-modal.vue